import { isString } from "./istype";

export function touchAllInputs() {
  // The big idea:
  //
  // As you're filling out a form, you don't want to see errors in the form when you're not done yet
  // So initially, the form fields are {tag: "initial"}. This causes them to get .has_initial classes
  // These are (by default) not styled, but are just so we can select them here
  // As you type something, (client-side) validations are ran but are slightly delayed so it's not annoying. If a field is filled out with an error, you'll see it after +- 200ms
  // When you click the saveButton, this procedure will run. All the inputs you didn't touch at all yet will now get touched, and with that the validations will run, and the .has_error classes will be applied if relevant
  document
    .querySelectorAll(
      ".has_initial input, input.has_initial, .has_initial textarea, textarea.has_initial, .has_initial select, select.has_initial",
    )
    .forEach((el) => {
      if ("value" in el && isString(el.value) && el.value.trim() === "") {
        el.dispatchEvent(new Event("input"));
      }
    });
  document
    .querySelectorAll(
      '.has_initial input[type="checkbox"], input[type="checkbox"].has_initial',
    )
    .forEach((el) => {
      el.dispatchEvent(new Event("change"));
    });
}
